import { createSlice } from "@reduxjs/toolkit";

interface AlarmInitialStateModel {
  filter:any;
}
const AlarmInitialState: AlarmInitialStateModel = {
  filter:{
    PageIndex:1,
    PageSize:20,
    SortProperty:"InsertDate",
    SortType:"asc"
  }
};

const alarmSlice = createSlice({
  name: "AlarmSlice ",
  initialState: AlarmInitialState,
  reducers: {
    handleSetAlarmFilter: (state, action) => {
      state.filter = action.payload.filter;
    },
    handleResetAlarmFitler: (state, ) => {
      state.filter = {
        PageIndex:1,
        PageSize:20,
        SortProperty:"InsertDate",
        SortType:"asc"
      };
    },
   
   
    
  },
});

export const {
  handleSetAlarmFilter,
  handleResetAlarmFitler,
} = alarmSlice.actions;
export default alarmSlice;
